import {Component} from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import Header from '@/header-nomenu';

const {NEXT_PUBLIC_NOINDEX = 'false'} = process.env;
const assetVersion = process.env.ASSET_VERSION || 'defaultVersion';
const defaultOgImage = `https://www.workable.com/static/images/workable_meta_image.jpg?v=${assetVersion}`;

const propTypes = {
  children: PropTypes.node.isRequired,
  centerAlignLogo: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  canonical: PropTypes.string.isRequired,
  ogtitle: PropTypes.string,
  ogdescription: PropTypes.string,
  ogimage: PropTypes.string,
  lightHeader: PropTypes.bool,
  noIndexMeta: PropTypes.bool
};

const NomenuLayout = ({
  children,
  centerAlignLogo,
  title,
  description,
  canonical,
  ogtitle = title,
  ogdescription = description,
  ogimage = defaultOgImage,
  lightHeader = true,
  noIndexMeta = false
}) => (
  <>
    <Head>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <title>{title}</title>
      <meta content={description} name="description" />
      <link href={canonical} rel="canonical" />
      <meta content={ogtitle} property="og:title" />
      <meta content={ogdescription} property="og:description" />
      <meta content={ogimage} property="og:image" />
      <meta content="website" property="og:type" />
      {(noIndexMeta || NEXT_PUBLIC_NOINDEX === 'true') && <meta name="robots" content="noindex" />}
    </Head>
    <Header lightHeader={lightHeader} isLogoCentered={centerAlignLogo} />
    {children}
  </>
);

NomenuLayout.propTypes = propTypes;
// Built using React HOCs
const NoMenu = (
  Page,
  metas = {
    title: 'Workable',
    description: `Workable’s online recruitment software goes beyond applicant tracking and posting jobs. It’s hiring software that improves the recruiting process and helps build a talent pool.`,
    canonical: 'https://www.workable.com/',
    ogimage: defaultOgImage
  }
) => {
  // eslint-disable-next-line react/prefer-stateless-function
  const WrappedPage = class extends Component {
    render() {
      return (
        <NomenuLayout {...metas}>
          <Page {...this.props} />
        </NomenuLayout>
      );
    }
  };

  return WrappedPage;
};

export default NoMenu;
